import { useMemo } from "react";

import type { DiscountListForDiscountQuery } from "@/lib/gql/__generated__/graphql";

import * as Repository from "../repository";
import { useTransitions } from "./use-transitions";

import type * as ModelType from "../type";

type Props = {
	hotelID: string;
	data: DiscountListForDiscountQuery;
};

export const useInitialized = ({ hotelID, data }: Props) => {
	/**
	 * QueryData の生成
	 */
	const queryData = useMemo((): ModelType.QueryData => {
		return data.discountList satisfies ModelType.QueryData;
	}, [data]);

	const {
		// ordinary
		onTransitionToAddOrdinaryDiscount,
		onTransitionToEditOrdinaryDiscount,
		onTransitionToDuplicateOrdinaryDiscount,

		// longTermStay
		onTransitionToAddLongTermStayDiscount,
		onTransitionToEditLongTermStayDiscount,
		onTransitionToDuplicateLongTermStayDiscount,

		// multi
		onTransitionToAddMultiDiscount,
		onTransitionToEditMultiDiscount,
		onTransitionToDuplicateMultiDiscount,
	} = useTransitions(hotelID);

	const { onDeleteDiscount } = Repository.Mutation.useDiscountDeleteMutation(hotelID);

	return {
		queryData,

		onDeleteDiscount,
		// ordinary
		onTransitionToAddOrdinaryDiscount,
		onTransitionToEditOrdinaryDiscount,
		onTransitionToDuplicateOrdinaryDiscount,

		// longTermStay
		onTransitionToAddLongTermStayDiscount,
		onTransitionToEditLongTermStayDiscount,
		onTransitionToDuplicateLongTermStayDiscount,

		// multi
		onTransitionToAddMultiDiscount,
		onTransitionToEditMultiDiscount,
		onTransitionToDuplicateMultiDiscount,
	};
};
